// IMPORTAÇÃO DOS COMPONENTES ---------------------------------------------------------------------
import { useState, useEffect } from 'react';
import styles from './contactModal.module.css';
import { api } from '../../../../services/api.js';
import { useTranslation } from 'react-i18next';



// COMPONENTE--------------------------------------------------------------------------------------
const ContactModal = ({ open, onClose }) => {

  // Hook de tradução
  const { t } = useTranslation();

  // opções de contatos (adicionar tambem no backend {translation.js} se alterar aqui)
  const SubjectOptions = [
    { value: 'solicitacao', label: t('Request') },
    { value: 'elogio', label: t('Praise') },
    { value: 'reclamacao', label: t('Complaint') },
    { value: 'erro', label: t('Error') },
  ];

  // Hooks 
  const [assunto, setAssunto] = useState(SubjectOptions[0].value);
  const [mensagem, setMensagem] = useState('');
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null); // { type: 'success'|'error', text: string }



  // função para limpar valores dos inputs
  const limpar = () => {
    setAssunto(SubjectOptions[0].value); setMensagem('');
  };



  // envia o e-mail via backend
  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus(null);

    if (!mensagem) {
      setStatus({ type: 'error', text: t('Please fill in the message.') });
      return;
    }

    setLoading(true);
    try {
      const response = await api.post('/contact/client', {
        subject: assunto,
        message: mensagem,
      });
      setStatus({ type: 'success', text: `${t(`Message sent successfully. We will get back to you soon. Deadline:`)} ${response.data.prazo} ${t('business days. Protocol No.')} ${response.data.protocolo}` });
      limpar();
    } catch (err) {
      console.error(err);
      const msg = t('Error sending message.');
      setStatus({ type: 'error', text: msg });
    } finally {
      setLoading(false);
    }
  };



  // Gerencia efeitos colaterais do modal (scroll lock, fechar com ESC).
  useEffect(() => {
    if (!open) {
      document.body.style.overflow = "";
      return;
    }
    document.body.style.overflow = "hidden";
    const handleEsc = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", handleEsc);

    // Função de limpeza
    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", handleEsc);
    };
  }, [open, onClose]);



  //modal fechado ao iniciar
  if (!open) return null;



  // html do componente
  return (
    <div className={styles.overlay} role="dialog" aria-modal="true">
      <div className={styles.modal}>
        <header className={styles.header}>
          <h3>{t('Contact Us')}</h3>
          <button className={styles.close} onClick={onClose} aria-label={t('Close')}>×</button>
        </header>

        <form className={styles.form} onSubmit={handleSubmit}>
          <label className={styles.title}>
            {t('Subject')}
            <select className={styles.slct} value={assunto} onChange={e => setAssunto(e.target.value)}>
              {SubjectOptions.map(opt => (
                <option key={opt.value} value={opt.value}>{opt.label}</option>
              ))}
            </select>
          </label>

          <label className={styles.title}>
            {t('Message') + ' *'}
            <textarea className={styles.txa} value={mensagem} onChange={e => setMensagem(e.target.value)} placeholder={t("Describe your message")} required rows={6} />
          </label>

          {status && (
            <div className={status.type === 'success' ? styles.success : styles.error}>
              {status.text}
            </div>
          )}

          <div className={styles.actions}>
            <button type="button" className={styles.btnGhost} onClick={() => { limpar(); onClose(); }} disabled={loading}>{t('Cancel')}</button>
            <button type="submit" className={styles.btnPrimary} disabled={loading}>
              {loading ? t('Sending...') : t('Send')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ContactModal;